import { secureApi } from './secureApi';

// Guest arrival EVIDENCE for one booking — did the guest's own door code open
// the lock, and when. Read-only, JWT-authenticated (admin/ops/ops-manager only).
//
// Its own endpoint rather than a field on the booking payload, deliberately: the
// inbox context panel will read this same resolver without fetching a whole
// booking, so the two surfaces can never drift apart.
//
// GET /api/v1/bookings/:bookingId/guest-arrival
// Response: { success, arrival: { status, arrivedAt, lastEntryAt, entryCount,
//                                 reason, source } }
//
// ⚠️ status NO_EVIDENCE means "we looked and found nothing" — NOT "the guest did
// not arrive". A guest can walk in on a shared building code. Never render it as
// a claim about the guest.
const guestArrivalApi = {
  get: async (bookingId) => {
    const response = await secureApi.get(`/api/v1/bookings/${bookingId}/guest-arrival`);
    return response.data;
  },

  /**
   * "Operations confirm this guest is inside, since this time" (tasks/manual-guest-arrival-confirm.md)
   * — for a guest let in on an internal/emergency code, whom the lock never saw. A SEPARATE fact
   * from the lock evidence `get` returns: it never changes that answer, and never clears a lock
   * warning. Its one consumer is the in-stay message «رسالة الاطمئنان».
   *
   * @param {string} bookingId
   * @param {string} observedAt - ISO instant the guest was inside, composed against Riyadh by the
   *   caller (`riyadhInputValueToIso`) — a datetime-local field carries no timezone.
   */
  recordGuestArrival: async (bookingId, observedAt) => {
    const response = await secureApi.post(
      `/api/v1/arrivals/${bookingId}/checked-in`,
      { observedAt },
      { preserveBackendError: true }
    );
    return response.data;
  },

  /** Withdraw a mis-pressed confirmation. Marked withdrawn, never deleted; logged both ways. */
  undoGuestArrival: async (bookingId) => {
    const response = await secureApi.delete(
      `/api/v1/arrivals/${bookingId}/checked-in`,
      { preserveBackendError: true }
    );
    return response.data;
  }
};

export default guestArrivalApi;
